/* "Watch our Lives" + LIVE NOW (snippets/ltx-lives.liquid, sections/ltx-promo-bar.liquid).
 *
 * Asks the live-check endpoint (Cloudflare Worker, cached 60s at the edge) and
 * fills every [data-ltx-lives] list, the LIVE NOW link and the promo-bar line.
 * Re-asks every 2 minutes while the tab is visible, so the badge clears when
 * the Live ends. Any failure leaves the badge OFF.
 *
 * "Shop the Live" is checked here, same-origin, because Shopify's storefront
 * answers 403 to the worker: HEAD /collections/live-MMDD.json → 200 or 404.
 *
 * ?ltx_live_test=1 fakes "on air" (newest Live as the broadcast) for checking
 * the badge on a preview. It only changes that visitor's page.
 */
(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-ltx-lives]'));
  var bars = Array.prototype.slice.call(document.querySelectorAll('[data-ltx-live-bar]'));
  if (!roots.length && !bars.length) return;
  var endpoint = (roots[0] || bars[0]).getAttribute('data-endpoint');
  if (!endpoint) return;
  var fakeLive = /[?&]ltx_live_test=1(&|$)/.test(location.search);
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var shopCache = {};

  /* "Thu · Oct 15" on the store's clock (the worker's handle uses Eastern too). */
  function dateLine(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', month: 'short', day: 'numeric' }).formatToParts(d);
      var get = function (t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return p[i].value; return ''; };
      return get('weekday') + ' · ' + get('month') + ' ' + get('day');
    } catch (e) {
      return DAYS[d.getDay()] + ' · ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    }
  }

  function shopUrl(handle) {
    if (!/^live-\d{4}$/.test(handle || '')) return Promise.resolve('');
    if (!shopCache[handle]) {
      var url = '/collections/' + handle;
      shopCache[handle] = fetch(url + '.json', { method: 'HEAD', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? url : ''; })
        .catch(function () { return ''; });
    }
    return shopCache[handle];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function item(live, shop) {
    var row = el('div', 'ltx-lives__item' + (live.live ? ' is-live' : ''));
    row.appendChild(el('span', 'ltx-lives__date', live.live ? 'On air now' : dateLine(live.date)));
    row.appendChild(el('span', 'ltx-lives__title', 'Facebook Live'));
    var links = el('span', 'ltx-lives__links');
    if (live.url) {
      var w = el('a', '', '▶ Watch');
      w.href = live.url; w.target = '_blank'; w.rel = 'noopener';
      links.appendChild(w);
    }
    if (shop) {
      var s = el('a', '', 'Shop the Live');
      s.href = shop;
      links.appendChild(s);
    }
    row.appendChild(links);
    return row;
  }

  function render(data) {
    var recent = (data && data.recent) || [];
    var live = !!(data && data.live && data.url);
    var liveUrl = live ? data.url : '';
    if (fakeLive && recent[0]) {
      live = true; liveUrl = recent[0].url; recent[0].live = true;
    }

    Promise.all(recent.map(function (r) { return shopUrl(r.collection); })).then(function (shops) {
      roots.forEach(function (root) {
        var list = root.querySelector('[data-ltx-lives-list]');
        if (list) {
          list.textContent = '';
          recent.forEach(function (r, i) { list.appendChild(item(r, shops[i])); });
        }
        var now = root.querySelector('[data-ltx-lives-now]');
        if (now) {
          now.hidden = !live;
          if (live) now.href = liveUrl;
        }
        root.classList.toggle('is-live', live);
      });
      bars.forEach(function (bar) {
        bar.hidden = !live;
        if (live) bar.href = liveUrl;
      });
    });
  }

  /* A failed check turns the badge off but keeps whatever list is showing. */
  function off() {
    roots.forEach(function (root) {
      var now = root.querySelector('[data-ltx-lives-now]');
      if (now) now.hidden = true;
      root.classList.remove('is-live');
    });
    bars.forEach(function (bar) { bar.hidden = true; });
  }

  function check() {
    var ctl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctl && setTimeout(function () { ctl.abort(); }, 6000);
    fetch(endpoint, { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) render(d); else off(); })
      .catch(off)
      .then(function () { if (timer) clearTimeout(timer); });
  }

  check();
  setInterval(function () { if (!document.hidden) check(); }, 120000);
})();
